/* eslint-disable no-unused-vars */
import axios from 'axios'

import { getAuthToken } from 'store/authConfig'
import { addToast } from 'components/Toast/actions'
import * as actionTypes from "../actionTypes"

export const JobRoleStart = () => {
    return {
        type: actionTypes.JOB_ROLE_START,
    }
}

const JobRoleGetSuccess = (data, page, size, filters, sorter, activeFilters, activeSorter) => {
    return {
        type: actionTypes.JOB_ROLE_GET_SUCCESS,
        data: data.data,
        active: page === "last" ? Math.ceil(data.pagination_data.total_count / 10 ): page,
        total: data.pagination_data.total_count,
        size,
        filters,
        sorter,
        activeFilters,
        activeSorter,
        activePage: page
    }
}

export const JobRoleDeleteSuccess = (id, renderPage) => {
    return {
        type: actionTypes.JOB_ROLE_DELETE_SUCCESS,
        renderPage,
        id
    }
}
const JobRoleCreateSuccess = () => {   
    return {
        type: actionTypes.JOB_ROLE_CREATE_SUCCESS,
        error : false,
    }
}

const JobRoleUpdateSuccess = (data) => {
    return {
        type: actionTypes.JOB_ROLE_UPDATE_SUCCESS,
        data: data.data
    }
}


export const JobRoleError = (err, dispatch, getError=false) => {
    try {
        if (err.response) {
            dispatch(addToast('error', 'Error', err.response.data.message))
            return {
                type: actionTypes.JOB_ROLE_ERROR,
                error: getError ? err.response.data.message : false
            }
        }
        dispatch(addToast('error', 'Error', err.message || "Something went wrong, please try after sometime."))
        return {
            type: actionTypes.JOB_ROLE_ERROR,
            error: getError ? (err.message || "Something went wrong, please try after sometime.") : false
        };
    } catch (error) {
        dispatch(addToast('error', 'Error', error.message))
        return {
            type: actionTypes.JOB_ROLE_ERROR,
            error: getError ? error.message : false
        }
    }
}

export const getJobRole = (page = 1, size = 10, filters, sorter, activeFilters, activeSorter, history) => {
    let url = `/api/jobs/role?page=${page}&page_count=${size}`

    Object.keys(filters).map(item => {
        url += `&${item}__icontains=${filters[item]}`
        return null
    })

    if (sorter) url += `&ordering=${sorter}`

    return dispatch => {
        getAuthToken()
        dispatch(JobRoleStart())
        axios.get(url).then(response => {
            if (response.data.data && response.data.pagination_data) dispatch(JobRoleGetSuccess(response.data, page, size, filters, sorter, activeFilters, activeSorter))
            if (response && response.data.data.length === 0 && response.data.error === 'Invalid page.' && history) {
                const total = response.data.total
                let nextPage
                if (total % 10 > 0) nextPage = total > 10 ? Math.ceil(total / 10) : 1
                else nextPage = Math.floor(total / 10)
                history.push({ pathname: '', search: `?page=${nextPage}` })
            }
        }).catch(error => {
            dispatch(JobRoleError(error, dispatch))
        })
    }
}

export const createJobRole = (data, history, next) => {
    getAuthToken()
    return dispatch => {
        dispatch(JobRoleStart())
        axios.post('/api/jobs/role', data).then(response => {
            dispatch(addToast('success', 'Success', 'Role Added Successfully'))
            dispatch(JobRoleCreateSuccess(response.data))
            history.push(`/jobrole?page=${next}`)
        }).catch((err) => {
            dispatch(JobRoleError(err, dispatch))
        })
    }
}

export const editJobRole = (id, newData, history, next) => {
    getAuthToken()
    return dispatch => {
        dispatch(JobRoleStart())
        let url = `/api/jobs/role/${id}`
        axios.patch(url, newData).then(response => {
            dispatch(addToast('success', 'Success', 'Role Edited Successfully'))
            dispatch(JobRoleUpdateSuccess(response.data))
            history.push(`/jobrole?page=${next}`)
        }).catch(err => {
            dispatch(JobRoleError(err, dispatch))
        })
    }
}

export const deleteJobRole = (jobRoleId, total, itemsPerPage, page, renderPage) => {
    getAuthToken()
    return dispatch => {
        dispatch(JobRoleStart())
        axios.delete(`/api/jobs/role/${jobRoleId}`).then(() => {
            dispatch(addToast('success', 'Success', 'Role Deleted Successfully'))
            const expectedPage = Math.ceil((total - 1) / itemsPerPage)
            const isRenderRequired = parseInt(page, 10) >= expectedPage ? `${renderPage}*` : renderPage
            dispatch(JobRoleDeleteSuccess(jobRoleId, isRenderRequired))
        }).catch(err => {
            dispatch(JobRoleError(err, dispatch))
        })
    }
}